import { Paper } from '@mui/material';
import { DateCalendar } from '@mui/x-date-pickers-pro';
import { useLocationHoursContext } from 'components/location-hours/location-hours.context';

const SideCalendar = () => {
  const {
    sideCalendar: { sideCalendarValue, setSideCalendarValue },
    temporaryHours: { temporaryHoursRef, changeToWeekOfDateView },
  } = useLocationHoursContext();

  return (
    <Paper
      elevation={3}
      sx={{
        display: { xs: 'none', md: 'block' },
      }}
    >
      <DateCalendar
        value={sideCalendarValue}
        onChange={dateSelect => {
          setSideCalendarValue(dateSelect);
          changeToWeekOfDateView(
            temporaryHoursRef.current?.getApi(),
            dateSelect,
          );
        }}
        views={['day']}
        sx={{ m: 0 }}
        data-testid="TemporaryHours.Calendar.SideCalendar"
      />
    </Paper>
  );
};

export default SideCalendar;
